import api, { ApiResponse } from './api';

export interface Leave {
  id: number;
  leaveId: number;
  employeeId: number;
  employeeName: string;
  leaveType: string;
  startDate: string;
  endDate: string;
  daysCount: number;
  reason?: string;
  status: string;
  createdDate: string;
  approvedBy?: number;
  approvedByName?: string;
  approvedDate?: string;
}

export interface LeaveCreateDto {
  employeeId: number;
  leaveType: string;
  startDate: string;
  endDate: string;
  reason?: string;
}

export interface LeaveUpdateDto {
  startDate?: string;
  endDate?: string;
  reason?: string;
}

export interface LeaveBalance {
  employeeId: number;
  totalDays: number;
  usedDays: number;
  remainingDays: number;
}

const leaveService = {
  getAll: async (): Promise<ApiResponse<Leave[]>> => {
    return api.get('/leaves');
  },

  getById: async (id: number): Promise<ApiResponse<Leave>> => {
    return api.get(`/leaves/${id}`);
  },

  getByEmployee: async (employeeId: number): Promise<ApiResponse<Leave[]>> => {
    return api.get(`/leaves/employee/${employeeId}`);
  },

  getPending: async (): Promise<ApiResponse<Leave[]>> => {
    return api.get('/leaves/pending');
  },

  create: async (data: LeaveCreateDto): Promise<ApiResponse<{ id: number }>> => {
    return api.post('/leaves', data);
  },

  update: async (id: number, data: LeaveUpdateDto): Promise<ApiResponse<{ id: number }>> => {
    return api.put(`/leaves/${id}`, data);
  },

  delete: async (id: number): Promise<ApiResponse<{ id: number }>> => {
    return api.delete(`/leaves/${id}`);
  },

  approve: async (id: number, notes?: string): Promise<ApiResponse<{ id: number }>> => {
    return api.post(`/leaves/${id}/approve`, { notes });
  },

  reject: async (id: number, reason?: string): Promise<ApiResponse<{ id: number }>> => {
    return api.post(`/leaves/${id}/reject`, { reason });
  },

  cancel: async (id: number): Promise<ApiResponse<{ id: number }>> => {
    return api.post(`/leaves/${id}/cancel`);
  },

  getBalance: async (employeeId: number): Promise<ApiResponse<LeaveBalance>> => {
    return api.get(`/leaves/balance/${employeeId}`);
  },
};

export default leaveService;
